import { render, staticRenderFns } from "./LogworkChildRow.vue?vue&type=template&id=23d308c5&scoped=true&"
import script from "./LogworkChildRow.vue?vue&type=script&lang=js&"
export * from "./LogworkChildRow.vue?vue&type=script&lang=js&"
import style0 from "./LogworkChildRow.vue?vue&type=style&index=0&id=23d308c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d308c5",
  null
  
)

export default component.exports